import InfoTooltip from './info-tooltip.component';

export * from './info-tooltip.d';
export default InfoTooltip;
